module.exports = __webpack_public_path__ + "assets/wechat.28725df0.svg";